import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8db5a352"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "banner"
};
var _hoisted_2 = {
  class: "dj-tabs-titles"
};
var _hoisted_3 = ["onClick"];

var _hoisted_4 = /*#__PURE__*/_createTextVNode("  ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_list = _resolveComponent("list");

  var _component_Tabs = _resolveComponent("Tabs");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "民主评议"
  }, {
    default: _withCtx(function () {
      return [_ctx.issecretary ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([_ctx.isactive == index ? 'is-active' : '']),
          onClick: function onClick($event) {
            return _ctx.titlechange(index);
          }
        }, _toDisplayString(item), 11, _hoisted_3);
      }), 128))])])) : _createCommentVNode("", true)];
    }),
    _: 1
  }), _createVNode(_component_Tabs, {
    title: _ctx.Data.titleArr,
    onChangeOther: _ctx.tabchange
  }, {
    decTit: _withCtx(function (_ref) {
      var item = _ref.item;
      return [_hoisted_4, _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.Data.totalNum) + "个", 513), [[_vShow, item.index == 0 && _ctx.Data.totalNum != 0]])];
    }),
    content0: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_list, {
        ref: "table1",
        totalNum: _ctx.Data.totalNum,
        "onUpdate:totalNum": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.Data.totalNum = $event;
        }),
        totalNumModifiers: {
          sync: true
        },
        "tabs-index": 0,
        "top-tabs-index": _ctx.Data.topTabsIndex,
        conditions: _ctx.Data.topTabsIndex == 0 ? {} : {
          secretaryUserId: _ctx.user
        },
        "api-name": _ctx.Data.topTabsIndex == 0 ? 'mydemocracy' : 'secretaryDemocracy'
      }, null, 8, ["totalNum", "top-tabs-index", "conditions", "api-name"]), [[_vShow, _ctx.Data.tabsIndex == 0]])];
    }),
    content1: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_list, {
        ref: "table2",
        "tabs-index": 1,
        "top-tabs-index": _ctx.Data.topTabsIndex,
        conditions: _ctx.Data.topTabsIndex == 0 ? {
          userId: _ctx.user
        } : {
          secretaryUserId: _ctx.user
        },
        "api-name": _ctx.Data.topTabsIndex == 0 ? 'myhisdemocracy' : 'secretaryHisDemocracy'
      }, null, 8, ["top-tabs-index", "conditions", "api-name"]), [[_vShow, _ctx.Data.tabsIndex == 1]])];
    }),
    _: 1
  }, 8, ["title", "onChangeOther"])], 64);
}